// SPDX-License-Identifier: BUSL-1.1

/**
 * HB-03 server-side activity events tab.
 *
 * Extracted from `routes/agent-detail.tsx` during the P3b refactor.
 */

import { DataTable } from '@/components/data-table';
import { eventColumns } from './event-columns';
import type { ActivityEvent } from './types';

export function EventsTab({
  eventData,
  isLoading,
  hasNextCursor,
}: {
  eventData: ActivityEvent[];
  isLoading: boolean;
  hasNextCursor: boolean;
}) {
  return (
    <>
      <DataTable
        columns={eventColumns}
        data={eventData}
        emptyMessage={
          isLoading
            ? 'Loading events...'
            : 'No activity events recorded for this agent yet.'
        }
      />
      {hasNextCursor && (
        <p className="mt-2 text-xs text-neutral-500">
          Showing the most recent {eventData.length} events. Older events
          available via the API (cursor-based pagination — UI pagination
          for &gt;100 events is a follow-up).
        </p>
      )}
    </>
  );
}
